var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandDetailsBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.14782 1.05392C4.69269 1.05392 3.51302 2.23358 3.51302 3.68871C3.51302 5.14384 4.69269 6.32351 6.14782 6.32351C7.60295 6.32351 8.78262 5.14384 8.78262 3.68871C8.78262 2.23358 7.60295 1.05392 6.14782 1.05392ZM2.45911 3.68871C2.45911 1.65146 4.11057 0 6.14782 0C8.18507 0 9.83653 1.65146 9.83653 3.68871C9.83653 5.72597 8.18507 7.37743 6.14782 7.37743C4.11057 7.37743 2.45911 5.72597 2.45911 3.68871Z",
    fill: "#143232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.08087 11.9445H11.215C10.9513 9.37877 8.78338 7.37743 6.14811 7.37743C3.51283 7.37743 1.34465 9.37871 1.08117 11.9445H1.08087ZM0 12.4715C0 9.07605 2.75253 6.32352 6.14796 6.32352C9.54338 6.32352 12.2959 9.07605 12.2959 12.4715C12.2959 12.7625 12.06 12.9984 11.769 12.9984H0.526959C0.235954 12.9984 0 12.7625 0 12.4715Z",
    fill: "#143232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandDetailsBlue);
export default __webpack_public_path__ + "static/media/brand-details-blue.667e26bfcfb0b652ac6f584d570abd57.svg";
export { ForwardRef as ReactComponent };